import { DATA_TEST_ID_PREFIX_BUTTON } from './constants'

export const getDataTestIdButton = (pageComponentIndex = '') =>
  `${DATA_TEST_ID_PREFIX_BUTTON}${pageComponentIndex}`
